const SA_INFO_ACCORDION_CONFIG = [
  {
    header: 'Komunikaty zarządu',
    body: 'W tym miejscu będą pojawiały się informacje związane z działalnością TrustMate SA',
  },
  {
    header: 'Walne Zgromadzenia Akcjonariuszy',
    body: 'W tym miejscu będą pojawiały się informacje związane z działalnością TrustMate SA',
  },
];

export default SA_INFO_ACCORDION_CONFIG;
